module.exports = __webpack_public_path__ + "static/media/goldf.b8f58d9c.png";